function isotopeInit(element, layoutMode, filterDefault){
	if (layoutMode == 'masonry') {
		element.isotope({
		  itemSelector: '.grid-item',
		  percentPosition: true,
		  layoutMode: layoutMode,
		  filter: filterDefault,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		});
	} else {
		element.isotope({
		  itemSelector: '.grid-item',
		  percentPosition: true,
		  layoutMode: layoutMode,
		  filter: filterDefault,
		  fitRows: {
		    gutter: '.gutter-sizer'
		  }
		});
	}
	return element;
}

function isotopeImagesLoaded(grid){
	grid.imagesLoaded().progress( function() {
	  grid.isotope('layout');
	});
}


function isotopeFilter(element, grid){

	element.find('.filters__list').on( 'click', 'button', function() {
	  var filterValue = $( this ).attr('data-filter');
	  // use filterFn if matches value
	  filterValue = filterValue;
	  grid.isotope({ filter: filterValue });
	});

}

function isotopeUpdateActive(element){
	element.find('.filters__item').each( function( i, buttonGroup ) {
	  $(this).on('click', 'button', function(){
	  	element.find('.filters__item').removeClass('active');
	  	$(this).parent('.filters__item').addClass('active');
	  });
	});
}


$(document).ready(function(){

	// init Isotope
	var $gridTeam 		= isotopeInit($('.grid--team'), 'fitRows', '*');
	var $gridActivity = isotopeInit($('.grid--activity'), 'fitRows', '*');
	var $gridSocial = isotopeInit($('.grid--social'), 'masonry', '*');
	
	if ($('html').attr('lang') == 'fr') {
		$gridActivity = isotopeInit($('.grid--activity'), 'fitRows', '.droitimmobilier');
	} else if ($('html').attr('lang') == 'en') {
		$gridActivity = isotopeInit($('.grid--activity'), 'fitRows', '.realestatelaw');
	} else {
		$gridActivity = $gridActivity;
	}

	// layout Isotope after each image loads
	isotopeImagesLoaded($gridActivity);
	isotopeImagesLoaded($gridTeam);
	isotopeImagesLoaded($gridSocial);


	// bind filter button click
	isotopeFilter($('.section--5'), $gridActivity);
	isotopeFilter($('.section--6'), $gridTeam);

	// change active class on buttons
	isotopeUpdateActive($('.section--5'));
	isotopeUpdateActive($('.section--6'));


});